import React, {useEffect} from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Routes, useNavigate} from 'react-router-dom';
import Home from "./components/Home";
import SearchEngines from "./components/SearchEngines";
import LinkList from "./components/LinkList";
import CollectionDetail from "./components/CollectionDetail";
import LandingPage from "./components/LandingPage";

const App: React.FC = () => {
  return (
      <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<Home />} />
          <Route path="/collection/:collectionId" element={<CollectionDetail />} />
      </Routes>
  );
}

const MainApp: React.FC = () => (
    <Router>
        <App />
    </Router>
);

export default MainApp;
